import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDuplicate(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M16 4c0-1-1-2-2-2H4a2 2 0 0 0-2 2v10c0 1 1 2 2 2h1a1 1 0 1 0 0-2H4V4h10v1a1 1 0 1 0 2 0V4Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 10c0-1-1-2-2-2H10c-1 0-2 1-2 2v10c0 1 1 2 2 2h10c1 0 2-1 2-2V10Zm-12 0h10v10H10V10Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
